exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1639192363/src/src/app/common/auto-logout/auto-logout.component.scss
// module id = ../../../../../src/app/common/auto-logout/auto-logout.component.scss
// module chunks = main